// React dependencies
import React from 'react';

// External dependencies
import { makeStyles, Paper, Typography } from '@material-ui/core';
import PropTypes from 'prop-types';

// Internal dependencies
import { IsEmpty } from '../../../common/checks';
import ProgressiveImage from '../../common/ProgressiveImage';
import convert from '../../../common/convert';
import { Colours } from '../../../common/constants';

const useStyles = makeStyles((theme) => ({
  paper: {
    padding:   theme.spacing(1),
    textAlign: 'center',
    color:     theme.palette.text.secondary,
  },
}));

const FormRow = (props) => {
  const classes = useStyles();

  return (
    <Paper className={classes.paper} elevation={2}>
      <Typography variant="subtitle1">
        <div style={{ height: 30, display: 'flex', alignItems: 'center' }}>
          <span style={{
            color:        '#000000',
            borderRight:  '1px dotted #e1e1e1',
            textAlign:    'left',
            borderWidth:  3,
            paddingLeft:  7,
            paddingRight: 7,
            minWidth:     80,
            height:       30,
            display:      'inline-flex',
            alignItems:   'center',
          }}
          >
            ID =
            {' '}
            {props.id}
          </span>
          <div style={{ flexGrow: 1, display: 'flex', justifyContent: 'center' }}>
            {
              (IsEmpty(props.link) || IsEmpty(props.fileType))
                ? <p style={{ color: Colours.Black }}>No Media</p>
                : (!IsEmpty(props.fileType) && props.fileType === 'image')
                  ? (
                    <ProgressiveImage
                      image={convert.imageResizeUrl(props.link, 30, 30)}
                      width={30}
                      height={30}
                      draggable={false}
                      style={{ objectFit: 'cover', display: 'block' }}
                    />
                  )
                  : (
                // eslint-disable-next-line jsx-a11y/media-has-caption
                    <video
                      src={props.link}
                      style={{
                        border:    '1px solid #CCC',
                        minWidth:  30,
                        maxWidth:  30,
                        height:    30,
                        maxHeight: 30,
                      }}
                    />
                  )
            }
          </div>
        </div>
      </Typography>
    </Paper>
  );
};

FormRow.propTypes = {
  id:       PropTypes.number.isRequired,
  fileType: PropTypes.string.isRequired,
  link:     PropTypes.string.isRequired,
};

export default FormRow;
